<h4 class="stepper-page-title title-4 mb-4" data-test-id="diagnosis-detail">Diagnosis Details</h4>

@if (isHhAuthForPacUser) {
  <p-message
    styleClass="w-full mb-4"
    severity="info"
    icon="pi pi-info-circle"
    data-test-id="diagnosis-info-message"
    [closable]="false"
    >
    <span class="font-bold">{{ diagnosisInfoMessage }}</span>
  </p-message>
}

<p-panel
  class="panel-padding mb-4"
  [toggleable]="false"
  header="Search for the applicable ICD-10 codes"
  data-test-id="diagnosis-details-header"
  >
  <form
    (keyup.enter)="search()"
    [formGroup]="searchForm"
    >
    <div class="flex items-center">
      <div class="flex gap-4">
        <div class="field mb-0">
          <label
            for="icdSearch"
            class="label"
            data-test-id="icd-code"
            ><span class="is-required">*</span>ICD-10 Code: </label>
            <input
              id="icdSearch"
              class="ml-4"
              pInputText
              type="text"
              formControlName="icdSearch"
              tabindex="1"
              data-test-id="icd-code-value"
              />
            </div>
            <button
              pButton
              type="button"
              label="Search"
              icon="pi pi-search"
              iconPos="left"
              [disabled]="searchForm.invalid"
              (click)="search()"
              data-test-id="icd-code-search"
            ></button>
          </div>
          @if (isLoading) {
            <p-progressSpinner
              styleClass="p-progress-spinner-sm"
            ></p-progressSpinner>
          }
        </div>
      </form>
    </p-panel>

    @if (!isPrimaryPDGM) {
      <p-message styleClass="w-100" severity="error" icon="pi pi-times-circle">
        {{ primaryICDWarningMessage }}
      </p-message>
    }

    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-6">
        <p-panel
          [toggleable]="false"
          header="Select up to 4 ICD codes"
          data-test-id="select-icd-codes-header"
          >
          <p-listbox
            [listStyle]="{ 'height': '200px' }"
            [options]="availableICDs"
            [readonly]="!canAddICDs"
            (onClick)="addICD($event)"
            data-test-id="select-icd-codes-listbox"
            >
            <ng-template let-icd let-i="index" pTemplate="item">
              <div
                class="diagnosis-list-item flex justify-between items-center"
                [attr.data-test-id]=" 'select-icd-code-item' + i + '-label'">
                {{icd.label}}
              </div>
            </ng-template>
          </p-listbox>
        </p-panel>
      </div>

      <div class="col-span-6">
        <p-panel
          [toggleable]="false"
          header="Click the up or down buttons to re-assign Primary, Secondary, Tertiary, and Quaternary codes"
          data-test-id="selected-icd-codes-header"
          >
          <p-listbox
            [options]="selectedICDs"
            [listStyle]="{ 'height': '200px' }"
            >
            <ng-template
              let-icd
              let-i="index"
              pTemplate="item"
              >
              <div class="diagnosis-list-item">
                <div
                  [attr.data-test-id]=" 'selected-icd-code-item' + i + '-label'"
                  class="mr-4"
                >
                  ({{orderTypeList[i]}}) - {{icd.label}}
                </div>
                <div class="diagnosis-list-buttons">
                  <button
                    pButton
                    type="button"
                    class="p-button-sm mr-2"
                    icon="pi pi-chevron-up"
                    iconPos="left"
                    [disabled]="i === 0"
                    (click)="moveUp(icd.value)"
                    [attr.data-test-id]=" 'selected-icd-code-item' + i + '-up'"
                  ></button>
                  <button
                    pButton
                    type="button"
                    class="p-button-sm mr-2"
                    icon="pi pi-chevron-down"
                    iconPos="left"
                    [disabled]="selectedICDs.length - 1 === i"
                    (click)="moveDown(icd.value)"
                    [attr.data-test-id]=" 'selected-icd-code-item' + i + '-down'"
                  ></button>
                  <button
                    pButton
                    type="button"
                    class="p-button-text p-button-sm"
                    icon="pi pi-times"
                    iconPos="left"
                    (click)="remove(icd)"
                    [attr.data-test-id]=" 'selected-icd-code-item' + i + '-remove'"
                  ></button>
                </div>
              </div>
            </ng-template>
          </p-listbox>
        </p-panel>
      </div>
    </div>

    <p-toast position="center"></p-toast>
